import { validateQueryStringParameters } from "../../helpers/api";
import { createBaseQuery } from "../helper/createBaseQuery";
import { tokenSlice } from "../slice/tokenSlice";

const approvalApi = tokenSlice.injectEndpoints({
  reducerPath: "approval",
  baseQuery: createBaseQuery(),
  tagTypes: ["Approval"],
  endpoints(builder) {
    return {
      // GET

      getApprovalRoles: builder.query({
        query: (businessUnitId) => ({
          url: `Approval/Roles/${businessUnitId}`,
          method: "GET",
        }),
        providesTags: ["Approval"],
      }),

      getApprovalStage: builder.query({
        query: (businessUnitId) => ({
          url: `Approval/Stage/${businessUnitId}`,
          method: "GET",
        }),
        providesTags: ["Approval"],
      }),

      getApprovalStages: builder.query({
        query: (params) => ({
          url: `Approval/Stages`,
          params: validateQueryStringParameters(params)
        }),
        providesTags: ["Approval"],
      }),

      getApprovalStageCard: builder.query({
        query: (mainId) => ({
          url: `Approval/ApprovalStage/${mainId}`,
          method: "GET",
        }),
        providesTags: ["Approval"],
      }),

      getApprovalProcedures: builder.query({
        query: () => ({
          url: "Approval/Procedures",
          method: "GET",
        }),
        providesTags: ["Approval"],
      }),

      // POST

      postSaveRole: builder.mutation({
        query: (data) => ({
          url: "Approval/SaveRole",
          method: "POST",
          body: data,
        }),
        invalidatesTags: ["Approval"],
      }),

      postSaveStage: builder.mutation({
        query: (data) => ({
          url: "Approval/SaveStage",
          method: "POST",
          body: data,
        }),
        invalidatesTags: ["Approval"],
      }),

      // DELETE

      deleteRole: builder.mutation({
        query: (data) => ({
          url: 'Approval/DeleteRole',
          method: 'DELETE',
          body: data
        }),
        invalidatesTags: ['Approval']
      }),

      deleteStage: builder.mutation({
        query: (data) => ({
          url: "Approval/DeleteStage",
          method: "DELETE",
          body: data,
        }),
        invalidatesTags: ["Approval"],
      }),

    };
  },
});

export const {
  useGetApprovalRolesQuery,
  useDeleteRoleMutation,
  usePostSaveRoleMutation,
  useGetApprovalStageQuery,
  useGetApprovalStagesQuery,
  useGetApprovalProceduresQuery,
  usePostSaveStageMutation,
  useDeleteStageMutation,
  useGetApprovalStageCardQuery
} = approvalApi;
export { approvalApi };
